export default {
  //@ts-ignore
  Cropper: () => import('@/components/Cropper.vue'),
  Prompt: () => import('@/components/Prompt.vue'),
  FreeStockPicker: () => import('@/components/FreeStockPicker.vue'),
  Login: () => import('@/views/Login.vue')
};
